/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PastMedicalHistoryDto
 */
export interface PastMedicalHistoryDto {
    /**
     * Diabetes
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    diabetes?: boolean;
    /**
     * Hypertension
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    hypertension?: boolean;
    /**
     * Heart disease
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    heartDisease?: boolean;
    /**
     * High cholesterol
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    highCholesterol?: boolean;
    /**
     * Asthma
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    asthma?: boolean;
    /**
     * Thyroid disorder
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    thyroidDisorder?: boolean;
    /**
     * Autoimmune disease
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    autoimmuneDisease?: boolean;
    /**
     * GERD
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    ibsIbd?: boolean;
    /**
     * GERD
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    gerd?: boolean;
    /**
     * Migraines
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    migraines?: boolean;
    /**
     * Anxiety/Depression
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    anxietyDepression?: boolean;
    /**
     * Chronic fatigue
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    chronicFatigue?: boolean;
    /**
     * Cancer
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    cancer?: boolean;
    /**
     * Cancer type
     * @type {string}
     * @memberof PastMedicalHistoryDto
     */
    cancerType?: string;
    /**
     * Neurological conditions
     * @type {boolean}
     * @memberof PastMedicalHistoryDto
     */
    neurologicalConditions?: boolean;
    /**
     * Other
     * @type {string}
     * @memberof PastMedicalHistoryDto
     */
    other?: string;
    /**
     * Additional notes related to the patient
     * @type {string}
     * @memberof PastMedicalHistoryDto
     */
    additionalNotes?: string;
}

/**
 * Check if a given object implements the PastMedicalHistoryDto interface.
 */
export function instanceOfPastMedicalHistoryDto(value: object): value is PastMedicalHistoryDto {
    return true;
}

export function PastMedicalHistoryDtoFromJSON(json: any): PastMedicalHistoryDto {
    return PastMedicalHistoryDtoFromJSONTyped(json, false);
}

export function PastMedicalHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PastMedicalHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'diabetes': json['diabetes'] == null ? undefined : json['diabetes'],
        'hypertension': json['hypertension'] == null ? undefined : json['hypertension'],
        'heartDisease': json['heartDisease'] == null ? undefined : json['heartDisease'],
        'highCholesterol': json['highCholesterol'] == null ? undefined : json['highCholesterol'],
        'asthma': json['asthma'] == null ? undefined : json['asthma'],
        'thyroidDisorder': json['thyroidDisorder'] == null ? undefined : json['thyroidDisorder'],
        'autoimmuneDisease': json['autoimmuneDisease'] == null ? undefined : json['autoimmuneDisease'],
        'ibsIbd': json['ibsIbd'] == null ? undefined : json['ibsIbd'],
        'gerd': json['gerd'] == null ? undefined : json['gerd'],
        'migraines': json['migraines'] == null ? undefined : json['migraines'],
        'anxietyDepression': json['anxietyDepression'] == null ? undefined : json['anxietyDepression'],
        'chronicFatigue': json['chronicFatigue'] == null ? undefined : json['chronicFatigue'],
        'cancer': json['cancer'] == null ? undefined : json['cancer'],
        'cancerType': json['cancerType'] == null ? undefined : json['cancerType'],
        'neurologicalConditions': json['neurologicalConditions'] == null ? undefined : json['neurologicalConditions'],
        'other': json['other'] == null ? undefined : json['other'],
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}

export function PastMedicalHistoryDtoToJSON(json: any): PastMedicalHistoryDto {
    return PastMedicalHistoryDtoToJSONTyped(json, false);
}

export function PastMedicalHistoryDtoToJSONTyped(value?: PastMedicalHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diabetes': value['diabetes'],
        'hypertension': value['hypertension'],
        'heartDisease': value['heartDisease'],
        'highCholesterol': value['highCholesterol'],
        'asthma': value['asthma'],
        'thyroidDisorder': value['thyroidDisorder'],
        'autoimmuneDisease': value['autoimmuneDisease'],
        'ibsIbd': value['ibsIbd'],
        'gerd': value['gerd'],
        'migraines': value['migraines'],
        'anxietyDepression': value['anxietyDepression'],
        'chronicFatigue': value['chronicFatigue'],
        'cancer': value['cancer'],
        'cancerType': value['cancerType'],
        'neurologicalConditions': value['neurologicalConditions'],
        'other': value['other'],
        'additionalNotes': value['additionalNotes'],
    };
}

